// extracted by mini-css-extract-plugin
module.exports = {"icon":"idt-windowedgiftdesignerui_icon__3zu30","spinner":"idt-windowedgiftdesignerui_spinner__nj17b"};